package ui

import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.rgba // <-- ✅ [추가] rgba import
import kotlin.math.roundToInt

// ✅ [수정] 아이콘 및 영문 표시 제거, 한글 라벨만 사용
fun verdictLabel(v: String) = when (v.lowercase()) {
    "avoid" -> "금지"
    "caution" -> "주의"
    "conditional" -> "조건부"
    "safe" -> "안전"
    else -> v
}

fun verdictColor(v: String) = when (v.lowercase()) {
    "avoid" -> Color("#ef4444")       // 빨강
    "caution" -> Color("#f59e0b")     // 주황
    "conditional" -> Color("#06b6d4") // 청록
    "safe" -> Color("#22c55e")        // 초록
    else -> Color.lightgray
}

// ✅ [추가] Verdict의 투명 배경색 (Components.kt에서 사용)
fun verdictBgRgba(v: String, alpha: Float = 0.15f) = when (v.lowercase()) {
    "avoid" -> rgba(239, 68, 68, alpha)
    "caution" -> rgba(245, 158, 11, alpha)
    "conditional" -> rgba(6, 182, 212, alpha)
    "safe" -> rgba(34, 197, 94, alpha)
    else -> rgba(211, 211, 211, alpha)
}

// ✅ [추가] 탭에 사용할 모든 Verdict 키 목록과 한글 라벨을 반환하는 함수
fun allVerdictTabs(): List<Pair<String, String>> {
    return listOf(
        "all" to "전체",
        "safe" to verdictLabel("safe"),
        "conditional" to verdictLabel("conditional"),
        "caution" to verdictLabel("caution"),
        "avoid" to verdictLabel("avoid")
    )
}

fun fmt1(n: Double): String = (kotlin.math.round(n * 10) / 10.0).toString()



